import TransportInfoGrid from './TransportInfoGrid';

export default TransportInfoGrid;
